import { Controller, FieldError, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { FormFieldWrapper } from 'components/shared/BaseFormComponents';
import { InputDatePicker, InputDayPicker } from 'components/shared/HookFormComponents/datePicker/inputs';
import { EOrganizedBy, ETripEvent, ITripEvent } from 'detailsv2/structure';
import { itineraryScheduleTypeSelector } from 'store/itinerariesItem/selectors';

import { IDaysOrDateActivity } from './types';

type RangeError = {
  start?: FieldError;
  end?: FieldError;
};

export const DayOrDatePicker = ({ isMultiDayActivity }: IDaysOrDateActivity) => {
  const { control } = useFormContext();
  const scheduleType = useSelector(itineraryScheduleTypeSelector);
  const isOrganizeByDate = scheduleType === EOrganizedBy.Date;

  if (isMultiDayActivity) {
    if (isOrganizeByDate) {
      return (
        <Controller<Partial<ITripEvent<ETripEvent.Activity>>, 'datesRange'>
          name="datesRange"
          control={control}
          render={(fieldProps) => {
            // previous form implementation, unchanged to avoid breaking changes
            // TODO: refactor with form
            const errorMessage = (fieldProps.fieldState.error as RangeError)?.end?.message;

            return (
              <FormFieldWrapper errorMessage={errorMessage}>
                <InputDatePicker placeholder="Start & End Date" mode="range" {...fieldProps} />
              </FormFieldWrapper>
            );
          }}
        />
      );
    }

    return (
      <Controller<Partial<ITripEvent<ETripEvent.Activity>>, 'daysRange'>
        name="daysRange"
        control={control}
        render={(fieldProps) => {
          // previous form implementation, unchanged to avoid breaking changes
          // TODO: refactor with form
          const errorMessage = (fieldProps.fieldState.error as RangeError)?.end?.message;

          return (
            <FormFieldWrapper errorMessage={errorMessage}>
              <InputDayPicker placeholder="Start & End Days" mode="range" {...fieldProps} />
            </FormFieldWrapper>
          );
        }}
      />
    );
  }

  if (isOrganizeByDate) {
    return (
      <Controller<Partial<ITripEvent<ETripEvent.Activity>>, 'datesRange'>
        name="datesRange"
        control={control}
        render={({ field, ...rest }) => {
          const { fieldState } = rest;
          const value = field.value?.start;
          const onChange = (val?: string | null) => field.onChange({ start: val, end: val });
          // previous form implementation, unchanged to avoid breaking changes
          // TODO: refactor with form
          const errorMessage = (fieldState.error as RangeError)?.end?.message;

          return (
            <FormFieldWrapper errorMessage={errorMessage}>
              {/* @ts-ignore TODO: refactor with form */}
              <InputDatePicker placeholder="Start Date" mode="single" field={{ ...field, value, onChange }} {...rest} />
            </FormFieldWrapper>
          );
        }}
      />
    );
  }

  return (
    <Controller<Partial<ITripEvent<ETripEvent.Activity>>, 'daysRange'>
      name="daysRange"
      control={control}
      render={({ field, ...rest }) => {
        const { fieldState } = rest;
        const value = field.value?.start;
        const onChange = (val?: number | null) => field.onChange({ start: val, end: val });
        // previous form implementation, unchanged to avoid breaking changes
        // TODO: refactor with form
        const errorMessage = (fieldState.error as RangeError)?.end?.message;

        return (
          <FormFieldWrapper errorMessage={errorMessage}>
            <InputDayPicker
              placeholder="Start Day"
              mode="single"
              hasError={!!errorMessage}
              // @ts-ignore TODO: refactor with form
              field={{ ...field, value, onChange }}
              {...rest}
            />
          </FormFieldWrapper>
        );
      }}
    />
  );
};
